// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5311": "94e581d461de","6195": "fdd14c5a4cd5","6863": "454c9f289029","8270": "72223c79a1b1","8357": "dd422574e14d",}[chunkId] + ".css"
}